export default __webpack_public_path__ + "static/media/todo_app_vanillaJS.8fdff890.PNG";